import { createSelector } from '@ngrx/store';
import { State } from '../state';
import { FiltersState } from './filters.state';
import { getFiltersModuleState } from '../feature-selector';
import { Attribute, Filters } from '~app/modules/filters/models';
import { isCategoryLoading } from '~app/modules/generic/store';
import { AttributeOption } from '~shared/models';
import { FILTER_ATTRIBUTE_KEYS } from '~app/modules/filters/constants';

export const getFiltersState = createSelector(getFiltersModuleState, (state: State) => state && state.filters);

export const getFilters = createSelector(getFiltersState, (state: FiltersState) => state && state.payload);

/* Filter Category selectors */
export const getCategories = createSelector(getFilters, (filters: Filters) => filters && filters.categories);

export const getChildCategories = createSelector(getFilters, (filters: Filters) => filters && filters.categoriesNext);

export const getFilterCategories = createSelector(getCategories, getChildCategories, (categories, childCategories) => [
  ...categories,
  ...childCategories,
]);

//blackdeal selectors
export const getBlackDealFilters = createSelector(getFilters, (filters: Filters) => filters && filters.blackFriday);
// promotion selectors
export const getPromotion = createSelector(getFilters, (filters: Filters) => filters && filters.promotion);
export const getVolumePrice = createSelector(getFilters, (filters: Filters) => filters && filters.volumePrices);

// attributes selectors
export const getAttributes = createSelector(getFilters, (filters: Filters) => (filters && filters.attributes) || []);

export const getRebuyGuarantee = createSelector(getAttributes, (attributes: Attribute[]) => {
  const characteristicsAttribute: Attribute =
    attributes && attributes?.find((attribute: Attribute) => attribute?.id === 'characteristics');

  return characteristicsAttribute?.options?.find(
    (attributeOption: AttributeOption) => attributeOption?.id === FILTER_ATTRIBUTE_KEYS.REBUY_GUARANTEE_OPTION
  );
});

// price selectors
export const getPriceRange = createSelector(getFilters, (filters: Filters) => filters && filters.priceRange);

// range selectors
export const getOptionsRange = createSelector(getFilters, (filters: Filters) => {
  return filters.attributes.filter((element) => element.optionsRange != null);
});

export const isPriceFilterVisible = createSelector(getFilters, (filters: Filters) => !!filters && !!filters.priceRange);

// general selectors
export const isFiltersLoading = createSelector(
  getFiltersModuleState,
  isCategoryLoading,
  (state: State, categoryLoading: boolean) => {
    const { filters } = state;
    return filters.loading || categoryLoading;
  }
);
